import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-car-model-location.png'


const _withScopeId = n => (_pushScopeId("data-v-569fa9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "header" }, "切换城市", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "section-header" }, "当前城市", -1))
const _hoisted_3 = { class: "location-info" }
const _hoisted_4 = { class: "location-city" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "重新定位", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "section-header" }, "附近城市", -1))
const _hoisted_9 = {
  class: /*#__PURE__*/_normalizeClass({
          'city-select-grid-layout-container': true,
          'nearby-city-grid-layout': true,
        })
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "section-header" }, "快速查找城市", -1))
const _hoisted_12 = {
  class: /*#__PURE__*/_normalizeClass({
          'city-select-grid-layout-container': true,
          'letter-grid-layout': true,
        })
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "section-header" }
const _hoisted_15 = {
  class: /*#__PURE__*/_normalizeClass({
          'city-select-grid-layout-container': true,
          'nearby-city-grid-layout': true,
        })
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_loading = _resolveComponent("van-loading")!

  return (_openBlock(), _createElementBlock("div", {
    class: "city-select-container",
    onTouchmove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: "city-select-warp",
      onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.webViewModel(true)), ["stop"])),
      onTouchmove: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.webViewModel(true)), ["stop"])),
      onTouchend: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.webViewModel(false)), ["stop"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.currentCity.city), 1),
        _createElementVNode("div", {
          class: "location-bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reLocate()))
        }, _hoisted_7)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearbyCities, (city) => {
          return (_openBlock(), _createElementBlock("div", {
            key: city.id,
            class: _normalizeClass({
            'grid-item-layout': true,
            nomal: _ctx.currentCity.city !== city.name,
            selected: _ctx.currentCity.city === city.name,
          }),
            onClick: ($event: any) => (_ctx.selectNearByCity(city))
          }, _toDisplayString(city.name), 11, _hoisted_10))
        }), 128))
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.letters, (letter, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: letter,
            class: _normalizeClass({
            'grid-item-layout': true,
            nomal: _ctx.selectLetter !== letter,
            selected: _ctx.selectLetter === letter,
            disabled:
              _ctx.allCitiesData.length > 0 && _ctx.allCitiesData[index].length === 0,
          }),
            onClick: ($event: any) => (_ctx.OnSelectLetter(letter, index))
          }, _toDisplayString(letter), 11, _hoisted_13))
        }), 128))
      ]),
      _createElementVNode("section", _hoisted_14, _toDisplayString(_ctx.selectLetter), 1),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showCities, (city) => {
          return (_openBlock(), _createElementBlock("div", {
            key: city.cityCode,
            class: _normalizeClass({
            'grid-item-layout': true,
            nomal: _ctx.currentCity.name !== city.cityName,
            selected: _ctx.currentCity.name === city.cityName,
          }),
            onClick: ($event: any) => (_ctx.selectCity(city))
          }, _toDisplayString(city.cityName), 11, _hoisted_16))
        }), 128))
      ])
    ], 32),
    _createElementVNode("div", _hoisted_17, [
      _withDirectives(_createVNode(_component_van_loading, {
        color: _ctx.activityInfo.subjectRgb,
        size: "40px"
      }, null, 8, ["color"]), [
        [_vShow, _ctx.isShowLoading]
      ])
    ])
  ], 32))
}